import Swal from 'sweetalert2';

/**
 * Chinese chrome for SweetAlert2, in one place.
 *
 * Before this existed the same strings were duplicated across eight files —
 * 30 copies of 'Error!' alone, and two different spellings of "Are you sure"
 * (one with a fullwidth ？). Callers pass only what is specific to them.
 */

const CONFIRM_COLOR = '#3085d6';
const CANCEL_COLOR = '#d33';

/** A yes/no confirmation. Resolves true only when the user confirms. */
export const confirmDialog = async (opts: { title: string; text?: string }): Promise<boolean> => {
    const result = await Swal.fire({
        title: opts.title,
        text: opts.text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: CONFIRM_COLOR,
        cancelButtonColor: CANCEL_COLOR,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
    });
    return result.isConfirmed;
};

/**
 * An error notice. `text` is optional because most existing callers passed
 * `error?.response` — an axios response object, which rendered as
 * "[object Object]" or blank. Pass a real string or nothing.
 */
export const errorDialog = (text?: string): Promise<unknown> =>
    Swal.fire({ title: '出错了', text, icon: 'error', confirmButtonText: '确定' });

/** A success notice. */
export const successDialog = (text?: string): Promise<unknown> =>
    Swal.fire({ title: '成功', text, icon: 'success', confirmButtonText: '确定' });
